module.exports = {
      id: "calendar-usage",
      viewBox: "0 0 17.552 17.301",
      url: "/" + "sprite-bc0169963456b1a4ad1bb8f1c406f483.svg#calendar",
      toString: function () {
        return this.url;
      }
    }